import { VariantColor } from '@repo/toolkit/colors'

import { getTranslatedName } from '../../../utils/functions/translation.functions'
import { TripSchedule } from '../../models/trips-schedule/trip-schedule'

export enum TripScheduleTypeEnum {
  RDV_LEC = 'RDV_LEC',
  RDV_PARENTS = 'RDV_PARENTS',
  RDV_STAFF = 'RDV_STAFF',
  RDV_PROVIDER = 'RDV_PROVIDER',
  TRANSFER = 'TRANSFER',
  DEPARTURE = 'DEPARTURE',
  RETURN = 'RETURN'
}

type Option = {
  label: string
  description?: string | React.ReactNode
  variant: VariantColor
}

export const tripScheduleTypeEnumMapping = (data: TripSchedule): Option => {
  switch (data.type) {
    case TripScheduleTypeEnum.DEPARTURE:
      return {
        label: `Départ ${getTranslatedName(data.transportMeans)}`,
        variant: 'purple',
        description: `Res. n° ${data.reservationNumber ?? ''} - ${' '}${data.departurePlace?.label ?? ''} → ${data.arrivalPlace?.label ?? ''}`
      }
    case TripScheduleTypeEnum.RETURN:
      return {
        label: `Arrivée ${getTranslatedName(data.transportMeans)}`,
        variant: 'blue',
        description: `Res. n° ${data.reservationNumber ?? ''} - ${' '}${data.departurePlace?.label ?? ''} → ${data.arrivalPlace?.label ?? ''}`
      }
    case TripScheduleTypeEnum.RDV_LEC:
      return {
        label: 'RDV Bureau LEC/AAT',
        variant: 'yellow',
        description: `${data.mission?.title ?? ''} - ${data.mission?.meetingPlace ?? ''}`
      }
    case TripScheduleTypeEnum.RDV_PARENTS:
      return {
        label: 'RDV Parents',
        variant: 'fushia',
        description: `${data.meetingPlace?.label ?? ''}`
      }
    case TripScheduleTypeEnum.RDV_PROVIDER:
      return {
        label: 'RDV Prestas',
        variant: 'yellow',
        description: `${data.tripProvider?.companyName ?? ''} - Res. n° ${data.reservationNumber ?? ''} - ${data.meetingPlace?.label ?? ''}`
      }
    case TripScheduleTypeEnum.RDV_STAFF:
      return {
        label: 'RDV Encadrants',
        variant: 'yellow',
        description: `${data.meetingPlace?.label ?? ''}`
      }
    case TripScheduleTypeEnum.TRANSFER: {
      return {
        label: 'RDV Transfers',
        variant: 'yellow',
        description: `${data.tripProvider?.companyName ?? ''} - Res. n° ${data.reservationNumber ?? ''} - ${data.departurePlace?.label ?? ''} - ${data.arrivalPlace?.label ?? ''}`
      }
    }
  }
}
